// // components/general/ProtectedRoute.jsx
// import { Navigate } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import { useAuth } from '../../../context/AuthContext';

// const ProtectedRoute = ({ children }) => {
//   const authContext = useAuth();
//   const [isChecking, setIsChecking] = useState(true);

//   useEffect(() => {
//     // Give time for auth context to load
//     const timer = setTimeout(() => {
//       setIsChecking(false);
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);

//   if (isChecking) {
//     return (
//       <div className="d-flex justify-content-center align-items-center min-vh-100">
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (!authContext?.token) {
//     return <Navigate to="/auth/login" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;


// components/general/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const authContext = useAuth();
  
  if (!authContext?.isInitialized) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!authContext?.token) {
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default ProtectedRoute;